export const GET_PROJECT_AUTH = 'project/GET_PROJECT_AUTH';
export const GET_PROJECT_LIST = 'project/GET_PROJECT_LIST';
export const GET_PROJECT = 'project/GET_PROJECT';
export const SET_CURRENT_PROJECT = 'project/SET_CURRENT_PROJECT';
export const GET_PROJECT_MEMBERS = 'project/GET_PROJECT_MEMBERS';
export const REMOVE_PROJECT_MEMBER = 'project/REMOVE_PROJECT_MEMBER';
export const REMOVE_SELECTED_PROJECT_MEMBERS = 'project/REMOVE_SELECTED_PROJECT_MEMBERS';
export const CREATE_PROJECT = 'project/CREATE_PROJECT';
export const DELETE_PROJECT = 'project/DELETE_PROJECT';
export const UPDATE_PROJECT_PERMISSIONS = 'project/UPDATE_PROJECT_PERMISSIONS';
export const INVITE_USER = 'project/INVITE_USER';
export const UPDATE_INVITE_STATUS = 'project/UPDATE_INVITE_STATUS';
export const IMPORT_PROJECT_URI = 'project/IMPORT_PROJECT_URI';
export const IMPORT_PROJECT_FILES = 'project/IMPORT_PROJECT_FILES';
export const SET_IMPORT_STATUS = 'project/SET_IMPORT_STATUS';
export const UPLOAD_IMPORT_COMPLETE = 'project/UPLOAD_IMPORT_COMPLETE';
export const URI_IMPORT_COMPLETE = 'project/URI_IMPORT_COMPLETE';
